import React from "react";
import IconBase from "./IconBase";

const Histogram = (props: any) => {
  return (
    <IconBase viewBox="0 0 25 20" {...props}>
      <path d="M0,11.015L 4.003,11.015L 4.003,16L0,16zM 5,5.015L 9.003,5.015L 9.003,16L 5,16zM 10,0L 14.011,0L 14.011,16L 10,16zM 15,5.014L 19.004,5.014L 19.004,16L 15,16zM 19.996,11.015L 24,11.015L 24,16L 19.996,16z" />
    </IconBase>
  );
};

export default Histogram;
